module.exports = __webpack_public_path__ + "img/zpqs.398e0dc0.jpg";